<template>
  <div class="header-wrappers">
    <div class="logo" v-if="!title">
      <!-- <div class="logo"> -->
      <router-link :to="{ path: '/', query: { lan: lang } }">
        <img src="../assets/img/shouye.png" alt="" />
      </router-link>
    </div>
    <div class="header-title iconfont iconfanhui" @click="back" v-else>
      {{ title }}
    </div>
    <div class="header-right" v-if="!lanshow">
      <span class="login" @click="login">{{ $tc("header.Login") }}</span>
    </div>
    <div class="header-right" v-if="lanshow">

      <div class="zhongxin">
        <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="onSelect">
          <template #reference>
            <!-- <van-button type="primary"
                          native-type="button">个人中心</van-button> -->
            个人中心
          </template>
        </van-popover>

      </div>
    </div>
    <!-- 登出确认弹框 -->
    <div class="confirm-pop" v-if="confirmFlag">
      <div class="confirm-inner">
        <h4>
          <img src="../assets/img/warning_icon.png" />
          <span>{{ $tc("header.confirmLogoutTitle") }}</span>
        </h4>
        <div class="confirm-btns">
          <span @click="confirmNo">{{ $tc("header.confirmLogoutNo") }}</span>
          <span @click="confirmYes" class="yes-btn">{{
              $tc("header.confirmLogoutYes")
            }}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Head',
  props: ['title', 'lanshow'],
  data () {
    return {
      confirmFlag: false,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: '查看详情' }, { text: '登出' }]
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      handler () {
        if (this.userInfo) {
          this.setActiveName(true)
          this.setUserInfo(this.userInfo)
        } else {
          this.setActiveName(false)
          this.setUserInfo('')
        }
      }
    }
    // ActiveName: {
    //   immediate: true,
    //   handler () {
    //     if (this.ActiveName) {
    //       this.setActiveName(true)
    //     } else {
    //       this.setActiveName(false)
    //     }
    //   }
    // }
  },
  computed: {
    ...mapState(['lang', 'userInfo', 'hisLen', 'ActiveName'])
  },
  created () {
  },
  methods: {
    ...mapMutations(['setLang', 'setUserInfo', 'setToastData', 'setHisLen', 'setActiveName']),
    onSelect (action) {
      // this.$toast(action.text);
      if (action.text == '查看详情') {
        this.toPersonal()
      }
      if (action.text == '登出') {
        this.confirmFlag = true
      }
    },
    changeLan () {
      this.$router.push({
        path: '/',
        query: {
          lan: this.lang === 'en' ? 'zh' : 'en'
        }
      })
    },
    back () {
      if (
        this.$route.query.from === 'yzg' ||
        this.$route.query.from === 'ylyzg'
      ) {
        window.history.back()
        return
      }
      if (window.history.length <= 1 || this.hisLen <= 1) {
        this.$router.replace({
          path: '/',
          query: {
            lan: this.lang
          }
        })
      } else {
        this.$router.go(-1)
      }
      this.setHisLen(this.hisLen - 1)
    },
    login () {
      const userInfo = this.userInfo
      if (userInfo) {
        this.confirmFlag = true
      } else {
        this.$router.push({
          path: '/login',
          query: {
            lan: this.lang
          }
        })
      }
    },
    confirmYes () {
      this.$Api
        .logout({})
        .then((data) => {
          this.confirmFlag = false
          localStorage.removeItem('userInfo')
          this.setUserInfo('')
          this.setToastData({
            text: this.$t('header.logoutsucess')
          })
          if (this.$router.history.current.path === '/') {
            window.location.reload()
          } else {
            this.$router.push('/')
          }
        })
        .catch((res) => {
          if (res === 403) {
            this.confirmFlag = false
            localStorage.removeItem('userInfo')
            this.setUserInfo('')
          } else {
            this.setToastData({
              text: this.$t('default.failed')
            })
          }
        })
    },
    confirmNo () {
      this.confirmFlag = false
    },
    toPersonal () {
      this.$router.push({
        path: '/personal'
      })
    }
  }
}
</script>

<style lang="scss">
.header-wrappers {
  background: #002eaa;
  padding: 0 2.685vw;
  box-sizing: border-box;
  height: 10.648vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  transform: scale(1);
  z-index: 999;
  .logo {
    width: 65.093vw;
    a {
      display: block;
    }
    img {
      width: 100%;
    }
  }
  .header-title {
    font-size: 4vw;
    color: #fff;
    font-weight: bold;
    margin-left: -2vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .header-right {
    display: flex;
    margin-left: 2.315vw;
    .lan {
      border: none;
    }
    .personal {
      background-color: #3a76ef;
    }
  }
  span {
    font-size: 3.704vw;
    color: #fff;
    border: 0.278vw solid #fff;
    min-width: 13.333vw;
    line-height: normal;
    height: 6.389vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 2vw;
    &.login {
      background-color: #e75e1e;
      margin-left: 2.315vw;
      white-space: nowrap;
    }
  }
  .loction {
    color: $color;
    font-size: 2.87vw;
    font-weight: bold;
    text-decoration: none;
    background-color: #00e4ff;
    height: 5.648vw;
    display: flex;
    align-items: center;
    padding: 0 2.222vw;
    margin-left: 2.315vw;
    white-space: nowrap;
    i {
      font-size: 3.704vw;
      margin-right: 0.741vw;
    }
  }

  .confirm-pop {
    position: absolute;
    left: 50%;
    top: 41.519vw;
    width: 65.926vw;
    background-color: #fff;
    border-radius: 0.926vw;
    box-shadow: 0 0 4.63vw #333;
    transform: translate(-50%, -100%);
    animation: bounceDown 0.3s forwards;
    z-index: 99;
    .confirm-inner {
      padding: 11.111vw 3.407vw 6.667vw;
      h4 {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 5vw;
          margin-right: 2.778vw;
        }
        span {
          font-size: 4.074vw;
          color: #000;
          line-height: 1.4;
          padding: 0;
          font-weight: normal;
        }
      }
      .confirm-btns {
        display: flex;
        justify-content: space-between;
        margin-top: 9.259vw;
        padding: 0 4vw;
        span {
          width: 22.222vw;
          height: 7.593vw;
          box-sizing: border-box;
          border: 1px solid #d9d9d9;
          border-radius: 0.926vw;
          font-size: 3.333vw;
          color: rgba(0, 0, 0, 0.65);
          &.yes-btn {
            color: #fff;
            border: none;
            background-color: #1890ff;
          }
        }
      }
    }
  }
  .nav-bar {
    margin-top: 25vw;
  }
}

@keyframes bounceDown {
  100% {
    transform: translate(-50%, 0);
  }
}
</style>
